<template>
  <div id="gfTooltipsNew"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'GTooltipsNew',
  data: () => ({}),
  created() {
    this.$center.gtooltip = this;
  },
  methods: {},
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

#gfTooltipsNew {
  svg {
    display: inline;
    vertical-align: unset;
  }
  .gfTooltipsItem {
    position: fixed;
    z-index: 9999999999;
    top: 0;
    left: 0;
    font-family: $fontFamily;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.01em;
    padding: 6px 8px;
    border-radius: 3px;
    display: none;
    background-color: $tooltips-background;
    border: $tooltips-background;
    color: $tooltips-color;
    animation-name: tooltips-fadeIn;
    animation-duration: 0.3s;
    transform: translateY(0px);
    display: block;

    $widthArrow: 4px;
    .gfTooltipsItemArrow {
      // Bottom
      position: absolute;
      border: $widthArrow solid transparent;
      border-bottom: $widthArrow solid $tooltips-arrow-color;
      border-top: none;
      transform: translate(-50%, 0);
      left: 50%;
      top: -$widthArrow;
    }
    &[data-postion='top'] {
      .gfTooltipsItemArrow {
        top: 100%;
        border: $widthArrow solid transparent;
        border-top: $widthArrow solid $tooltips-arrow-color;
      }
    }
    &[data-postion='left'] {
      .gfTooltipsItemArrow {
        transform: translate(0, -50%);
        top: 50%;
        left: 100%;
        border: $widthArrow solid transparent;
        border-left: $widthArrow solid $tooltips-arrow-color;
      }
    }
    &[data-postion='right'] {
      .gfTooltipsItemArrow {
        transform: translate(0, -50%);
        top: 50%;
        left: -$widthArrow - $widthArrow;
        border: $widthArrow solid transparent;
        border-right: $widthArrow solid $tooltips-arrow-color;
      }
    }
  }

  .gfTooltipsItemBox {
    position: fixed;
    z-index: 9999999999;
    top: 0;
    left: 0;
    font-family: $fontFamily;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.25px;
    text-align: center;
    padding: 32px;
    border-radius: 3px;
    display: none;
    color: $neutral_4;
    background-color: $white;
    animation-name: tooltips-fadeIn;
    animation-duration: 0.3s;
    transform: translateY(0px);
    display: block;
    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.2);
    a {
      color: #ffc439;
    }

    $widthArrow: 8px;
    .gfTooltipsItemClose {
      position: absolute;
      padding: 10px;
      cursor: pointer;
      right: 8px;
      top: 13px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 10px;
        color: $neutral_4;
        transition: color 0.3s;
      }
    }
    .gfTooltipsItemTitle {
      font-size: 16px;
      margin-bottom: 14px;
      color: $neutral_1;
      text-align: center;
      font-weight: 600;
    }
    .gfTooltipsItemButton {
      font-size: 14px;
      margin-top: 32px;
      color: rgba($white, 0.6);
      span {
        cursor: pointer;
        border-radius: 3px;
        font-size: 14px;
        margin-top: 14px;
        padding: 8px;
        color: $neutral_3;
        background: $neutral_8;
        text-align: center;
        width: 100%;
        transition: all 0.2s;
        display: block;
        font-weight: 600;
        &:hover {
          color: $neutral_5;
        }
      }
    }
    .gfTooltipsItemArrow {
      // Bottom
      position: absolute;
      border: $widthArrow solid transparent;
      border-bottom: $widthArrow solid $neutral_9;
      border-top: none;
      transform: translate(-50%, 0);
      left: 50%;
      top: -$widthArrow;
    }
    &[data-postion='top'] {
      .gfTooltipsItemArrow {
        top: 100%;
        border: $widthArrow solid transparent;
        border-top: $widthArrow solid #606569;
      }
    }
    &[data-postion='left'] {
      .gfTooltipsItemArrow {
        transform: translate(0, -50%);
        top: 50%;
        left: 100%;
        border: $widthArrow solid transparent;
        border-left: $widthArrow solid #606569;
      }
    }
    &[data-postion='right'] {
      .gfTooltipsItemArrow {
        transform: translate(0, -50%);
        top: 50%;
        left: -$widthArrow - $widthArrow;
        border: $widthArrow solid transparent;
        border-right: $widthArrow solid #606569;
      }
    }
  }
}

#gfTooltipsNew .gfTooltipsItemBox.popup-preview-chooser {
  padding: 0;
  text-align: left;
  .gfTooltipsItemButton {
    margin-top: 12px;
  }
  a {
    &.btn-outline {
      color: $text-light-high;
    }
    &.btn-primary {
      color: $light1;
    }
  }
  .popup-preview_header {
    border-bottom: 1px solid $text-dark-high;
  }
  .popup-preview_footer {
    .btn:not(:first-child) {
      margin-left: 8px;
    }
  }
}
</style>
